import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from '../queries/queryKeys';

const onDeleteDocumentsFilter = async (id) => {
  return await request.delete(
    `/Filter?id=${id}`,
    null,
    'При удалении фильтра произошла ошибка',
    'Error'
  );
};

const useDeleteDocumentsFilter = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(onDeleteDocumentsFilter, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      if (data.success) {
        queryClient.invalidateQueries(queryKeys.savedFilters());
      }
    },
  });

  return {
    isDeleteDocumentsFilterLoading: mutation.isLoading,
    onDeleteDocumentsFilter: mutation.mutateAsync,
  };
};

export default useDeleteDocumentsFilter;
